import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { route } from "../routes";
import OptionsContext from '../contexts/options';
import {
  withRouter,
  withError,
  Form,
  FormHeader,
  FormGroup,
  FormLabel,
  FormAdvancedDescription,
  FormFooter,
  FormSubmit,
  Textfield,
  Select,
  Link,
} from "cw-styleguide-react";

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
      sector: '',
      level: '',
      location: '',
      proximity: '4'
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    // Preset the filters.
    if (this.state.keyword) {
      this.props.setFilter('keyword', this.state.keyword);
    }

    if (this.state.sector) {
      this.props.addFilter('sector', this.state.sector);
    }

    if (this.state.level) {
      this.props.addFilter('level', this.state.level);
    }

    if (this.state.location) {
      this.props.setFilter('location', this.state.location);
    }

    if (this.state.proximity) {
      this.props.setFilter('proximity', this.state.proximity);
    }

    const parameters = this.props.convertFiltersToParameters(this.state);

    this.props.setQuery(parameters);
    this.props.navigate(route('results') + parameters);
  }

  handleClick(e) {
    e.preventDefault();

    this.props.loadApprenticeships();
    this.props.navigate(route('results'));
  }

  render() {
    return (
      <OptionsContext.Consumer>
        {({ sectors, apprenticeshipLevels, proximity }) => (
          <Form theme={['no-padding', 'no-background', 'on-colour', 'inline-groups']}>
            <FormHeader title={this.props.t('view.search.title')} isPageTitle={true}
              introduction={this.props.t('view.search.introduction')} />

            {/*Keyword*/}
            <FormGroup type={'textfield'} size={'medium'}>
              <FormLabel for={'keyword'}>
                {this.props.t('filters.keyword.label')}
              </FormLabel>
              <Textfield id={'keyword'} name={'keyword'} value={this.state.keyword}
                placeholder={this.props.t('filters.keyword.placeholder')}
                onChange={this.handleChange} />
            </FormGroup>

            {/*Sector*/}
            <FormGroup type={'select'} size={'medium'}>
              <FormLabel for={'sector'}>
                {this.props.t('filters.sector.label')}
              </FormLabel>
              <Select id={'sector'} name={'sector'} value={this.state.sector} onChange={this.handleChange}
                options={[{
                  value: '',
                  label: this.props.t('misc.all')
                }].concat(sectors)} />
            </FormGroup>

            {/*Apprenticeship Level*/}
            <FormGroup type={'select'} size={'medium'} classes={['form__group--new-line']}>
              <FormLabel for={'level'}>
                {this.props.t('filters.level.label')}
              </FormLabel>
              <Select id={'level'} name={'level'} value={this.state.level} onChange={this.handleChange}
                options={[{
                  value: '',
                  label: this.props.t('misc.all')
                }].concat(apprenticeshipLevels)} />
              <FormAdvancedDescription link={{ text: this.props.t('filters.level.help.label') }}>
                <div dangerouslySetInnerHTML={{ __html: this.props.t('filters.level.help.text.short') }} />
              </FormAdvancedDescription>
            </FormGroup>

            {/*Location*/}
            <FormGroup type={'textfield'} size={'medium'}>
              <FormLabel for={'location'}>
                {this.props.t('filters.location.label')}
              </FormLabel>
              <Textfield id={'location'} name={'location'} value={this.state.location} onChange={this.handleChange} />
            </FormGroup>

            {/*Proximity*/}
            <FormGroup type={'select'} size={'medium'}>
              <FormLabel for={'proximity'}>
                {this.props.t('filters.proximity.label.long')}
              </FormLabel>
              <Select id={'proximity'} name={'proximity'} value={this.state.proximity} onChange={this.handleChange}
                options={proximity} />
            </FormGroup>

            <FormFooter>
              <FormSubmit title={'Search'} icon={{ type: 'chevron-right', position: 'right' }} value={'Search'}
                onClick={this.handleSubmit}>
                {this.props.t('misc.search')}
              </FormSubmit>
              <p>
                {this.props.t('misc.or')}&nbsp;
                <Link className={'style--icon-right-chevron-right'} to={route('results')} onClick={this.handleClick}>
                  {this.props.t('misc.viewAll')}
                </Link>
              </p>
            </FormFooter>
          </Form>
        )}
      </OptionsContext.Consumer>
    );
  }
}

export default withError(withRouter(withTranslation('local')(SearchForm)));
